import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow p-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium mb-3" }, "Any questions?", -1)
const _hoisted_3 = { class: "flex items-center justify-start" }
const _hoisted_4 = { class: "text-sm leading-2 font-medium text-black" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_MailIcon = _resolveComponent("MailIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "w-12 h-12 rounded-lg bg-gray-100 mr-4 flex justify-center items-center",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.getAdvisorImage(_ctx.advisor.email)})`, 'background-size': 'cover' })
      }, [
        false
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("IMG")
            ], 64))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.advisor.name), 1),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.advisor.phone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `tel:${_ctx.advisor.phone}`,
                class: "px-2 py-1 text-xs bg-white border rounded-md inline-flex items-center mt- mr-2 opacity-80 pointer-events-none"
              }, [
                _createVNode(_component_PhoneIcon, { class: "w-3 h-3 mr-1" }),
                _createTextVNode(" Call ")
              ], 8, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: `mailto:${_ctx.advisor.email}`,
            class: "px-2 py-1 text-xs bg-white border rounded-md inline-flex items-center mt-2"
          }, [
            _createVNode(_component_MailIcon, { class: "w-3 h-3 mr-1" }),
            _createTextVNode(" Email ")
          ], 8, _hoisted_7)
        ])
      ])
    ])
  ]))
}